import { render, staticRenderFns } from "./AllocationOrdP.vue?vue&type=template&id=0dadd24d&scoped=true"
import script from "./AllocationOrdP.vue?vue&type=script&lang=js"
export * from "./AllocationOrdP.vue?vue&type=script&lang=js"
import style0 from "./AllocationOrdP.vue?vue&type=style&index=0&id=0dadd24d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadd24d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dadd24d')) {
      api.createRecord('0dadd24d', component.options)
    } else {
      api.reload('0dadd24d', component.options)
    }
    module.hot.accept("./AllocationOrdP.vue?vue&type=template&id=0dadd24d&scoped=true", function () {
      api.rerender('0dadd24d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/AllocationOrdP.vue"
export default component.exports